const initialState = {
  resultsCabanaCategoriesList: [],
  resultsCabanaCategoryAdd: {},
  resultsCabanaCategoryEdit: {},
  resultsCabanaCategoryDelete: {},
  resultsCabanaCategory: {},
  loading: false,
  resultsCabanasUnmappedCount: {},

};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_CABANA_CATEGORIES_RESPONSE_GET":
      newState.resultsCabanaCategoriesList = action.value;
      newState.loading = false;
      break;
    case "CABANA_CATEGORY_RESPONSE_ADD":
      newState.resultsCabanaCategoryAdd = action.value;
      newState.loading = false;
      break;
    case "CABANA_CATEGORY_RESET":
      newState.resultsCabanaCategoryAdd = {};
      break;
    case "CABANA_CATEGORY_RESET_LIST":
      newState.resultsCabanaCategoriesList = [];
      break;
    case "CABANAS_CATEGORY_RESPONSE_GET":
      newState.resultsCabanaCategory = action.value;
      newState.loading = false;
      break;
    case "CABANAS_CATEGORY_RESPONSE_EDIT":
      newState.resultsCabanaCategoryEdit = action.value;
      newState.loading = false;
      break;
    case "LIST_CABANAS_UNMAPPED_COUNT_RESPONSE_GET":
      newState.resultsCabanasUnmappedCount = action.value;
      break;
    case "RESET_CATEGORY_RESPONSES":
      newState.resultsCabanaCategoriesList = [];
      newState.resultsCabanaCategoryAdd = {};
      newState.resultsabanaCategoryEdit = {};
      newState.resultsabanaCategoryDelete = {};
      break;
    case "CABANA_CATEGORY_RESPONSE_DELETE":
      newState.resultsCabanaCategoryDelete = action.value;
      newState.loading = false;
      break;


    default:
      break;
  }
  return newState;
};

export default reducer;
